import React, { useRef, useEffect, useState } from 'react';
import styles from './section.module.css';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Link, useLocation } from 'react-router-dom';
import { slideImg1, slideImg2, slideImg3, slideImg4 } from '../../../assets';
import useTextAnimation from '../../hooks/useTextAnimation';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from "react-redux";
import { fetchOurWorkData } from "../../slice/workSlice";
import { IMAGE_URL } from "../../helpers/api_helper";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Loading from '../loading/Loading';

gsap.registerPlugin(ScrollTrigger);

const SectionThird = () => {
    const vSlider = [slideImg1, slideImg2, slideImg3, slideImg4];
    const imagesRef = useRef([]);
    const [loaderComplete, setLoaderComplete] = useState(false);
    const [showExploreMore, setShowExploreMore] = useState(false);


    const dispatch = useDispatch();
    const { data: workData, loading, error } = useSelector((state) => state.work);
    const {t,i18n}= useTranslation()
    const navigateTo = useNavigate();




    useEffect(() => {
        dispatch(fetchOurWorkData());
    }, [dispatch]);

    useEffect(() => {
        // Simulate page loader completion
        const timer = setTimeout(() => {
            setLoaderComplete(true); // Loader is complete
        }, 2000); // Adjust duration to match your loader

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (!loaderComplete) return;

        const container = document.querySelector(`.${styles.imageGrid}`);
        container.style.perspective = '2500px';

        // Create an array to track animation completions
        let completedAnimations = 0;

        ScrollTrigger.matchMedia({
            "(min-width: 1024px)": () => {
                imagesRef.current.forEach((image, index) => {
                    const timeline = gsap.timeline({
                        scrollTrigger: {
                            trigger: image,
                            start: 'top bottom',
                            end: 'bottom top',
                            scrub: true,
                        },
                    });

                    timeline.to(image, {
                        keyframes: [
                            {
                                translateY: '50vh',
                                translateZ: '-200vw',
                                rotateX: '-135deg',
                                duration: 0,
                            },
                            {
                                translateY: '0vh',
                                translateZ: '-100vw',
                                rotateX: '0deg',
                                duration: 0.5,
                            },
                            {
                                translateY: '-25vh',
                                translateZ: '-200vw',
                                rotateX: '135deg',
                                duration: 0.5,
                                onComplete: () => {
                                    completedAnimations++;
                                },
                            },
                        ],
                    });
                });
            },
            "(max-width: 1025px)": () => {
                imagesRef.current.forEach((image) => {
                    gsap.killTweensOf(image);
                    gsap.set(image, { clearProps: 'all' });
                });
            },
        });

        return () => {
            ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
        };
    }, [loaderComplete]); // Run effect only after loaderComplete is true

    const workSectionRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
        if (location.state?.fromWorkDetail && workSectionRef.current) {
            workSectionRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [location]);



    return (
        <>

            <>
                <div className={styles.workSec_inner}>
                    <div className={styles.works_title_wrapper}>
                        <h2 className={styles.workTitle}>{t('homeWork')}</h2>
                    </div>
                </div>

                {loading &&  <Loading />}

                {!loading && (
                <div className={styles.imageGrid}>
                    {/* {workData.map(({ _id, image, homeBannerImage}, index) => (
                        <div key={_id} className={styles.imageContainer}>
                            <Link to="/our-work" ref={(el) => (imagesRef.current[index] = el)}>
                                <img src={`${IMAGE_URL}/work/${homeBannerImage}`} alt={`Slide ${index + 1}`} />
                            </Link>
                        </div>
                    ))} */}

                   {/*  {Array.isArray(workData) && workData.map(({ _id, image, homeBannerImage }, index) => (
                        <div key={_id} className={styles.imageContainer}>
                            <Link to= {`/our-work/work-detail/${_id}`} ref={(el) => (imagesRef.current[index] = el)}>
                                <img src={`${IMAGE_URL}/work/${homeBannerImage}`} alt={`Slide ${index + 1}`} loading='lazy' />
                            </Link>
                        </div>
                    ))} */}

                    {Array.isArray(workData) && workData.map(({ _id, homeBannerImage }, index) => (
                        <div key={_id} className={styles.imageContainer} /* onClick={()=> navigateTo(`/our-work/work-detail/${_id}`)} */>
                            <Link to={`/our-work/work-detail/${_id}`} state={{ fromWorkSection: true }} ref={(el) => (imagesRef.current[index] = el)}>
                                <img src={`${IMAGE_URL}/work/${homeBannerImage}`} alt={`Slide ${index + 1}`} loading="lazy" />
                            </Link>
                        </div>
                    ))}

                </div>

                )}


                <div className={styles.exploreMore}>
                    <Link to={`/our-work`} className='arab'>
                        {t('homeExplore')} <span><svg width="20.123" height="19.718" viewBox="0 0 20.123 19.718">
                            <defs>
                                <clipPath id="clipPath">
                                    <rect id="Rectangle_2464" data-name="Rectangle 2464" width="20.123" height="19.718" fill="none" />
                                </clipPath>
                            </defs>
                            <g id="Group_9348" data-name="Group 9348" transform="translate(0 0)">
                                <g id="Group_9347" data-name="Group 9347" transform="translate(0 0)" clipPath="url(#clipPath)">
                                    <path id="Path_13955" data-name="Path 13955" d="M2.281,19.305a1.468,1.468,0,0,1,.035-1.565L15.2,2.576l-13.75.615A1.214,1.214,0,0,1,.976.811L18.1,0a1.114,1.114,0,0,1,1.219,1.109l.806,17.123a1.177,1.177,0,0,1-2.3.254l-.8-14.251L4.14,19.4a1.61,1.61,0,0,1-1.479.252Z" transform="translate(0 0)" fill="#DD043D" />
                                </g>
                            </g>
                        </svg></span>
                    </Link>
                </div>
            </>
        </>
    );
};

export default SectionThird;
